module.exports = __webpack_public_path__ + "img/icon_4_18.c23ff80a.png";